import { useEffect } from 'react'
import ModalComponent from '../../../../shared/components/Modals/ModalComponent'
import ModalBody from '../../../../shared/components/Modals/ModalBody'
import { useDispatch, useSelector } from 'react-redux'
import { selectAllKits, selectAllTemplates, selectInterviewKitNameModalOpen, selectSelectedKitTemplateData, setAllKits, setInterviewKitNameModalOpen, setSelectedKitTemplateData, setTemplates } from "../../slice/interviewSlice"
import { Button, Form, Input, message } from 'antd';
import { useState } from 'react';
import { formHasErrors } from '../../../../shared/utils/functions/handleFormChanges';
import AddNew from "../../../../shared/assets/images/AddNew.svg"
import { setSettingsModalOpen } from "../../../settings/slice/settingsSlice"
import { useSaveKitAsTemplateMutation } from '../../slice/interviewApiSlice'
import { apiStatuses, errorMessage, interviewKitTemplates } from '../../../../shared/utils/constantData'
import { CheckboxDropdownItem } from '../../../../shared/utils/interfaces/settingsInterface'
export const InterviewKitNameModal = ({ kitTitle, fromProfile = false }: { kitTitle?: string, fromProfile?: boolean }) => {
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(false);
    const dispatch = useDispatch();
    const isOpen = useSelector(selectInterviewKitNameModalOpen)
    const kitTemplateData = useSelector(selectSelectedKitTemplateData)
    const allKits = useSelector(selectAllKits)
    const templates = useSelector(selectAllTemplates)
    const [saveKitAsTemplate, { isLoading: isLoadingSaving, isError: isErrorSaving, isSuccess: isSuccessSaving, error: savingError, data: saveTemplateData }] = useSaveKitAsTemplateMutation();

    useEffect(() => {
        form.setFieldValue('title', kitTemplateData?.data?.title)
    }, [kitTemplateData,form])

    useEffect(() => {
        if (isSuccessSaving) {
            message.success('Interview kit saved Successfully')
            dispatch(setInterviewKitNameModalOpen(false))
            if (!fromProfile) {
                dispatch(setSettingsModalOpen(true))
                const interviewTemplate = allKits.find((kit: CheckboxDropdownItem) => kit?.children?.length)?.children
                let updatedInterviewTemplateChildren: CheckboxDropdownItem[]
                if (interviewTemplate?.length) {
                    updatedInterviewTemplateChildren = [...interviewTemplate, { key: saveTemplateData?.data?.id, label: saveTemplateData?.data?.data?.title, parentKey: interviewKitTemplates }]
                    const updatedAllKits = allKits?.map((kit) => kit?.children?.length ? { ...kit, children: updatedInterviewTemplateChildren } : kit)
                    dispatch(setAllKits(updatedAllKits))
                } else {
                    const kits = allKits.slice(0, allKits.length - 1)
                    const updatedKits = [...kits, { key: interviewKitTemplates, label: interviewKitTemplates, visibleTopDivider: true, children: [{ key: saveTemplateData?.data?.id, label: saveTemplateData?.data?.data?.title, parentKey: interviewKitTemplates }] }]
                    dispatch(setAllKits([...updatedKits, allKits[allKits.length - 1]]))
                }
            } else {
                dispatch(setTemplates([...templates, { key: saveTemplateData?.data?.id, label: saveTemplateData?.data?.data?.title }]))
            }
        } else if (isErrorSaving) {
            message.error(savingError?.status === apiStatuses.badRequest ? errorMessage : savingError?.data?.message || errorMessage, 5)
        }
        //eslint-disable-next-line
    }, [isSuccessSaving, isErrorSaving, savingError, dispatch])

    async function onFinish(values: { title: string }) {
        const { title } = values
        const { id, ...rest } = kitTemplateData
        const interviewTemplate = fromProfile ? templates : allKits.find((kit: CheckboxDropdownItem) => kit?.children?.length)?.children
        const updatedInterviewTemplateChildren = interviewTemplate?.length ? [...interviewTemplate, { key: title, label: title }] : [{ key: title, label: title }]
        const interviewTemplateNames = updatedInterviewTemplateChildren?.map(({ label }: CheckboxDropdownItem) => label.trim().toLowerCase().replace('', ''));
        const uniqueNames = new Set(interviewTemplateNames);
        const isUniqueName = uniqueNames.size === interviewTemplateNames.length;
        isUniqueName ? await saveKitAsTemplate({ data: { ...rest.data, title } }) : message.error('Template name should be unique per company')
    }

    function closeInterviewKitNameModal(): void {
        dispatch(setSelectedKitTemplateData({}));
        dispatch(setInterviewKitNameModalOpen(false))
        dispatch(setSettingsModalOpen(true))
    }

    const handleFormChange = () => {
        setIsDisabled(formHasErrors(form));
    }

    return (
        <ModalComponent
            visibleModal={isOpen}
            handleCloseModal={!isLoadingSaving ? closeInterviewKitNameModal : () => { }}
            content={
                <ModalBody
                    icon={AddNew}
                    title='Interview Kit Template Name'
                    subtitle='Note: All interview templates will be saved in profile settings'
                >
                    <Form
                        form={form}
                        className='text-start'
                        size='large'
                        onFinish={onFinish}
                        onFieldsChange={handleFormChange}
                        initialValues={{ title: kitTemplateData?.data?.title || kitTitle }}
                    >
                        <Form.Item
                            name="title"
                            rules={[{ required: true, message: 'Template Name is missing' }]}
                        >

                            <Input
                                className='w-full text-sm font-normal text-gray-600 placeholder-gray-400 capitalize rounded-md border-gray-300 !py-4 shadow-sm'
                                size="large"
                                placeholder="Template Name"
                            >
                            </Input>
                        </Form.Item>
                        <Form.Item
                            className='mb-0'
                        >
                            <Button
                                loading={isLoadingSaving}
                                disabled={isDisabled || isLoadingSaving}
                                className="w-full btn-primary btn-lg"
                                htmlType='submit'
                            >
                                Save
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalBody>
            }
        />
    )
}
